import axios from 'axios';
import { createSignedGetRequest } from 'utils/createSignedRequestsHelpers';
import { ADMIN_AI_LOCAL_API_REQUESTS } from './constants';

/**
 * GET /admin/ai/licences — every AI assistant licence row (active or
 * cancelled) plus every business charged in the current month, as
 * `{ generatedAt, yearMonth, freeTierMonthlyUsd, businesses }`; system admin
 * only.
 */
export const getAdminAiLicences = async () => {
  const signedRequest = await createSignedGetRequest({
    apiPath: 'admin/ai/licences',
    isLocalApiRequest: ADMIN_AI_LOCAL_API_REQUESTS,
  });
  const response = await axios(signedRequest);
  return response.data;
};
